/* =========================================================
   PC BUILDER SEARCH (FINAL, STABLE, UI PRESERVED)
   Uses builder cache: window.csCalcAllProducts
   ========================================================= */

(function () {

  /* ==================== DOM ELEMENTS ==================== */
  const searchContainer = document.getElementById('cs-calc-search-container');
  const searchInput = document.getElementById('cs-calc-search-input');
  const searchResults = document.getElementById('cs-calc-search-results');

  if (!searchContainer || !searchInput || !searchResults) return;

  const MAX_RESULTS = 20;
  const MIN_QUERY_LENGTH = 2;

  /* ==================== DATA SOURCE ==================== */
  function getAllSearchableProducts() {
    if (!window.csCalcAllProducts) return [];

    const results = [];

    Object.keys(window.csCalcAllProducts).forEach(category => {
      const products = window.csCalcAllProducts[category] || [];
      products.forEach(product => {
        results.push({
          ...product,
          category
        });
      });
    });

    return results;
  }

  /* ==================== HELPERS ==================== */
  function normalize(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getProductImage(product) {
    const raw =
      product.image ||
      product.imageUrl ||
      product.image_url ||
      product.images?.[0] ||
      '';

    if (!raw) return '';

    return typeof convertGoogleDriveUrl === 'function'
      ? convertGoogleDriveUrl(raw)
      : raw;
  }

  /* ==================== SEARCH LOGIC ==================== */
  function searchProducts(query) {
    const q = normalize(query);
    if (q.length < MIN_QUERY_LENGTH) return [];

    return getAllSearchableProducts().filter(product => {
      const searchableText = normalize([
  product.name,
  product.brand,
  `${product.brand || ''} ${product.name || ''}`, // ✅ BRAND + NAME
  product.category,
  product.specs,
  product.socket,
  product.chipset,
  product.capacity,
  product.wattage
].join(' '));


      return searchableText.includes(q);
    }).slice(0, MAX_RESULTS);
  }

  /* ==================== RENDER RESULTS ==================== */
  function renderResults(results) {
    if (!results.length) {
  searchResults.innerHTML = `
    <div class="cs-calc-search-no-results">
      No products found for "<strong>${searchInput.value}</strong>"
    </div>
  `;
  searchResults.style.display = 'block';
  return;
}

    const isMobile = window.innerWidth <= 768;

    searchResults.innerHTML = results.map(product => `
      <div class="cs-calc-search-item"
           data-category="${product.category}"
           data-product-id="${product.id}">
        <img
          class="cs-calc-search-item-image"
          src="${getProductImage(product)}"
          alt="${product.name}">
        <div class="cs-calc-search-item-text">
          <div class="cs-calc-search-item-name">
            ${product.brand ? `${product.brand} ${product.name}` : product.name}
          </div>
        <div class="cs-calc-search-item-meta">
         <span class="cs-calc-search-price">₹ ${product.price}</span>
         <span class="cs-calc-search-separator">•</span>
         <span class="cs-calc-search-category">${product.category}</span>
        </div>

        </div>
        ${isMobile ? '' : `<button class="cs-calc-search-select-btn">SELECT</button>`}
      </div>
    `).join('');

    searchResults.style.display = 'block';
  }

  /* ==================== EVENTS ==================== */
  searchInput.addEventListener('input', function () {
    const query = this.value.trim();
    if (query.length < MIN_QUERY_LENGTH) {
      searchResults.style.display = 'none';
      return;
    }
    renderResults(searchProducts(query));
  });

  searchResults.addEventListener('click', function (e) {
    const item = e.target.closest('.cs-calc-search-item');
    if (!item) return;

    searchResults.style.display = 'none';
    searchInput.value = '';

    selectViaSearch(item.dataset.category, item.dataset.productId);
  });

  document.addEventListener('click', function (e) {
    if (!searchContainer.contains(e.target)) {
      searchResults.style.display = 'none';
    }
  });

  /* ==================== SELECTION HANDLER ==================== */
  function selectViaSearch(category, productId) {

    // Activate category tab
    if (typeof activateCategoryTab === 'function') {
      activateCategoryTab(category);
    }

    const products = window.csCalcAllProducts[category];
    if (!products) return;

    const index = products.findIndex(p => p.id === productId);
    if (index === -1) return;

    // IMPORTANT: let builder reset its state first
    loadCategoryProducts(category).then(() => {

      // 🔑 FINAL FIX: set page AFTER builder renders
      const itemsPerPage = window.innerWidth <= 880 ? 4 : 9;
      currentPage = Math.floor(index / itemsPerPage) + 1;

      displayCurrentPage();
      updatePaginationControls();

      setTimeout(() => {
        const card = document.querySelector(
          `.cs-calc-card[data-category="${category}"][data-product-id="${productId}"]`
        );

        if (!card) return;

        const selectBtn = card.querySelector('.cs-calc-btn');
        if (selectBtn) selectBtn.click();

        card.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 150);

    });
  }

})();
